var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-reality-currency"},[_vm._v(" You have "),_c('b',{class:_vm.resourceClass()},[_vm._v(" "+_vm._s(_vm.currencyValue)+" ")]),_vm._v(" "+_vm._s(_vm.currencyName)+". ")])}
var staticRenderFns = []

export { render, staticRenderFns }